import { GetPackageModel } from "@factory/model/query-model-package";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { packageFormDefault } from "./form.default";
import { PackageFormSchema } from "./form.rule";

export const useFormDefaultPackage = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetPackageModel | undefined) => {
    return !cachedValue
      ? packageFormDefault
     : ({
        name: cachedValue.name,
        numPeople: cachedValue.num_people,
        unit: cachedValue.unit,
        sizeDescription: cachedValue.size_description,
      } as PackageFormSchema);
  };

  return {
    getDefault,
  };
};
